import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { TextInput } from '../../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { ButtonFilledAutoWidth } from '../../../components/button'
import { CreateCaseTypeService, UpdateCaseTypeService } from '../../../services/CaseTypeService'

function CaseTypeCE() {
 
  const [data,setdata] = useState({name:''});  
  const [error,seterror] = useState({name:''}); 
  
  const {state} = useLocation();
  const navigate = useNavigate();

  // const {id,department_name} = state;

  console.log("state",state)

  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      setdata({...data,name:state.name})
    }

  },[state])

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    console.log("iam there na")
    if(!data.name){
        seterror({...error,name:'Case Type Name field is required *'})
    }else{

        if(state?._id === undefined || state?._id === null){
        const response = await CreateCaseTypeService(data)
        if (response.status === 201) {
          setdata({...data,name:''})
          seterror({...error,name:''})
          toast.success('Case Type Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,name:response?.data?.errors?.name})
        } 
      }else{
        let send_data = {...data}
        send_data["id"] = state?.id
        const response = await UpdateCaseTypeService(send_data,state?._id)
        if (response.status === 200) {
          setdata({...data,name:''})
          seterror({...error,name:''})
          navigate(-1)
          toast.success('Case Type Updated Successfully')
        }   
        if(response.status === 422){
          seterror({...error,name:response?.data?.errors?.name})
        } 
      }
  }
  }

  

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
 
  <div className='sm:w-full lg:w-72 px-4 pt-5' >


      <GoBack /> 
      

        <h6 className='font-bold'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'}  Case Type</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Case Type</b> for your company employees.</h6>
     

        <TextInput 
            label={'Case Type'}  
            variant="standard"
            name="name"
            type="text"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder="Enter your Case Type name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

<div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE CASE TYPE" : "ADD CASE TYPE"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default CaseTypeCE